import { atom, useAtom } from "jotai";

type CompanyOption = {
  label: string;
  value: number;
};

const companyOptionsAtom = atom<CompanyOption[]>([]);

function useGetCompanyOptions() {
  const [companyOptions, setCompanyOptions] = useAtom(companyOptionsAtom);
  return {
    companyOptions,
    setCompanyOptions,
  };
}

export default useGetCompanyOptions;
